import React from "react";
import { Link } from "react-router-dom";
import { Translate } from "react-redux-i18n";
import { connect } from "react-redux";

import "./styles/TransactionList.css";

import ModalGodiwayer from "../components/ModalGodiwayer";
import ModalCalificationRequest from "../components/ModalCalificationRequest";
import ModalTransferDetails from "../components/ModalTransferDetails";
import TransactionUserChip from "../components/TransactionUserChip";
import * as actions from "../redux/actions/contactsActions";
import MiniLoader from "./MiniLoader";

function getStatusClass(status) {
  if (status === "FINISHED") return "transaction-card__status--finished";
  return "transaction-card__status--pending";
}

class TransactionItem extends React.Component {
  render() {
    const { item, userRoleLabel } = this.props;
    const showRating =
      item.Status !== "FINISHED" && item.CalificationUser == null;

    return (
      <article className="transaction-card">
        <Link
          to={`/goder/show/${item.Ad.Id}`}
          className="transaction-card__media"
        >
          <img
            className="transaction-card__img"
            src={item.Ad.Photo}
            alt={item.Ad.Name}
          />
          {item.KindCommerceId != null && (
            <span className="transaction-card__kind">
              <Translate value={"kind_commerce" + item.KindCommerceId} />
            </span>
          )}
        </Link>

        <div className="transaction-card__body">
          <div className="transaction-card__header">
            <h3 className="transaction-card__title">
              <Link to={`/goder/show/${item.Ad.Id}`}>{item.Ad.Name}</Link>
            </h3>
            <span
              className={`transaction-card__status ${getStatusClass(item.Status)}`}
            >
              {item.Status}
            </span>
          </div>

          <dl className="transaction-card__meta">
            <div className="transaction-card__meta-row">
              <dt>
                <Translate value="transaction_date" />
              </dt>
              <dd>{item.CreatedAt}</dd>
            </div>
            <div className="transaction-card__meta-row">
              <dt>
                <Translate value="transaction_quantity" />
              </dt>
              <dd>{item.Quantity}</dd>
            </div>
          </dl>

          <TransactionUserChip
            user={item.User}
            roleLabel={userRoleLabel}
            onOpenProfile={this.props.onOpenProfile}
            onClickChat={this.props.onClickChat}
            transactionId={"GW-T" + item.Id}
            onViewTransfer={
              item.PaymentOption === "transfer"
                ? this.props.onViewTransfer
                : null
            }
            onViewCalification={
              showRating ? this.props.onViewCalification : null
            }
          />
        </div>
      </article>
    );
  }
}

class TransactionRequestList extends React.Component {
  state = {
    open_modal_calification: false,
    open_modal_profile: false,
    open_modal_transfer: false,
    transferAdId: null,
    transaction: {},
    contact: {},
    sellerContact: null,
  };

  onClickViewProfile = (user, sellerContact) => {
    this.setState({
      open_modal_profile: true,
      contact: user,
      sellerContact: sellerContact || null,
    });
  };

  onCloseModalProfile = () => {
    this.setState({ open_modal_profile: false, sellerContact: null });
  };

  onCloseModalCalification = () => {
    this.setState({ open_modal_calification: false });
  };

  onClickChat = (item) => {
    this.props.SetContact(item.User);
  };

  onViewCalification = (item) => {
    this.setState({
      open_modal_calification: true,
      transaction: item,
    });
  };

  onViewTransfer = (item) => {
    this.setState({
      open_modal_transfer: true,
      transferAdId: item.Ad.Id,
    });
  };

  onCloseTransfer = () => {
    this.setState({ open_modal_transfer: false, transferAdId: null });
  };

  render() {
    if (
      this.props.pageCount === 0 ||
      this.props.transactionList.length === 0
    ) {
      return (
        <div className="transaction-list__empty">
          <Translate value="transaction_not_list" />
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className="transaction-list">
          {this.props.transactionList.map((item) => (
            <TransactionItem
              item={item}
              key={item.Id.toString()}
              userRoleLabel={<Translate value="transaction_seller" />}
              onOpenProfile={(user) => this.onClickViewProfile(user, item.SellerContact)}
              onClickChat={() => {
                this.onClickChat(item);
              }}
              onViewCalification={() => {
                this.onViewCalification(item);
              }}
              onViewTransfer={() => {
                this.onViewTransfer(item);
              }}
            />
          ))}
        </div>

        {this.props.pageSize >= 4 &&
          (this.props.loadingMore ? (
            <div className="transaction-list__load-more">
              <MiniLoader />
            </div>
          ) : (
            <div className="transaction-list__load-more">
              <button
                type="button"
                className="transaction-list__load-more-btn"
                onClick={() => {
                  this.props.onClickLoadMore();
                }}
              >
                <Translate value="load_more" />
              </button>
            </div>
          ))}

        <ModalGodiwayer
          isOpen={this.state.open_modal_profile}
          onClose={() => {
            this.onCloseModalProfile();
          }}
          item={this.state.contact}
          sellerContact={this.state.sellerContact}
          identityOnly
          showChatAction={false}
        />
        <ModalCalificationRequest
          isOpen={this.state.open_modal_calification}
          onClose={() => {
            this.onCloseModalCalification();
          }}
          transaction={this.state.transaction}
        />
        <ModalTransferDetails
          isOpen={this.state.open_modal_transfer}
          onClose={this.onCloseTransfer}
          adId={this.state.transferAdId}
        />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  SetContact: (item) => dispatch(actions.setContact(item)),
});

export default connect(null, mapDispatchToProps)(TransactionRequestList);
